export enum ValidationStepState {
	Wait = 20,
	Ready = 30,
	Running = 40,
	Successful = 60,
	Failed = 80,
	Blocked = 90,
}
